export const mealType = {
  1: "图片",
  2: "音频",
  3: "视频",
};
export const accountTypeList = {
  1: "支付宝",
  2: "中国工商银行",
  3: "中国农业银行",
  4: "交通银行",
  5: "中国银行",
  6: "中国建设银行",
  7: "招商银行",
  8: "浦发银行",
  9: "中国民生银行",
  10: "邮政储蓄银行",
};
